import styled from "styled-components";

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100%;    
    color: #000;
    font-family: 'Inter', Arial, sans-serif;
    font-size: 12px;    

`;